<template>
	<div class="main" v-title data-title="零部件个人中心">
		<iHeader ref="loginIndex"></iHeader>
		<div class="flexRow justBetween barprebox mt25">
			<vnav></vnav>
			<div class="contR bgwhite">
				<div class="mt25 ml20">
					<div class="Ctitle">
						<h1 class="color1 font18 item1">浏览记录</h1>
					</div>
				</div>
				<div class="formWBasehist" v-if="historylist.length!=0">
					<el-row class="histCol" :gutter="20">
						<el-col :span="6" v-for="(item,index) in historylist" :key="index" class="curhand" style="margin-top: 10px;">
							<div class="colDP" @click="jumpurl(item.id)">
								<span>
									<el-image :src="'https://images.mfcad.cn/'+item.thumb"
									 fit="cover"></el-image>
								</span>
								<div class="colDPimg mt10">
									<!-- <p class="Cred">¥ 5.19起</p> -->
									<p class="overtitleOne">{{item.title}}</p>
									<p class="col-666">品牌</p>
								</div>
							</div>
						</el-col>
					</el-row>
					<div class="block pdb10 mt40" style="float: right">
						<el-pagination @current-change="handleCurrentChange"@size-change="handSizeChange"  :current-page.sync="page" :page-sizes="[12, 24, 36]"
						 :page-size="100" layout="prev, pager, next,sizes,total" :total='total'>
						</el-pagination>
					</div>
				</div>
				<div class="formWBasehist txc" v-else>
					暂无数据
				</div>
			</div>
		</div>
		<v-footer></v-footer>
	</div>
</template>

<script>
	// 公共头部组件
	import iHeader from "@/components/indexheader"
	import vnav from "@/components/leftnav"
	import vFooter from "@/components/Footer"
	import "@/assets/cont-01.css";
	import Vue from 'vue';
	import axios from 'axios';
	Vue.prototype.$axios = axios;
	import Cookies from 'js-cookie'
	export default {
		components: {
			iHeader,
			vFooter,
			vnav,
		},
		data() {
			return {
				total: 1,
				pcount: '12', //每页多少条
				page: 1, //当前页码数
				historylist: [],
			};
		},
		created() {
			this.handhistorylist();
		},
		methods: {
			//点击第几页
			handleCurrentChange(val) {
				this.page = val;
				this.handhistorylist();
			},
			handSizeChange(val){
				this.pcount=val;
				this.handhistorylist()
			},
			handhistorylist() {
				this.$postcn('partshome/browsingPersonal', {
					p: this.page, //第几页
					pcount: this.pcount, //一页显示多少条
				}, this).then((res) => {
					// console.log(res)
					if (res.data.code == 200 && res.data.code!=-4004) {
						this.historylist = res.data.data.data
						this.total = res.data.data.count
					}else if(res.data.code==-4004){
						this.$refs.loginIndex.handLogin(window.location.href)
					}else{
						this.$message({
							type: 'error',
							message: res.data.msg
						});
					}
				})
			},
			jumpurl(id) {
				let routeData = this.$router.resolve({
					path: "/content",
					query: {
						goodsid: id
					}
				})
				window.open(routeData.href, '_blank');
			},
		}
	}
</script>

<style scoped>
	.histCol .colDP {
		border: 1px solid #ccc;
	}
	
	.histCol .colDP span {
		height: 150px;
		display: block;
	}
	.histCol .colDP span .el-image{
		padding: 10px;
		height: 150PX;
	}
	.histCol .colDP span img {
		/* width: 120px;
		     height: 120px;
		     padding: 10px; */
		width: 100%;
		height: 150px;
	}
	
	.histCol .colDPimg {
		text-align: left;
		padding-left: 10px;
		font-size: 14px;
		line-height: 25px;
		margin-top: 18px;
	}
	
	.histCol .colDPimgR {
		text-align: left;
		padding-left: 10px;
		line-height: 20px;
		margin-top: 15px;
		padding-right: 38px;
	}
	.list-item .noticeD {
		position: relative;
		min-height: 14px;
		padding: 0px 20px;
		line-height: 15px;
		color: #999;
		font-size: 12px;
	}

	.Ctitle {
		height: 35px;
		line-height: 35px;
		vertical-align: middle;
		margin-right: 20px;
		border-bottom: 1px solid #ccc;
	}

	.el-divider {
		margin: 12px 0px;
	}
	.formWBasehist{
		padding: 20px;
	}
</style>



// WEBPACK FOOTER //
// src/pages/people/history.vue